import React, { useMemo, useState } from 'react';
import { Card, Col, Row, Button, Nav, Tab } from 'react-bootstrap';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';


const OrganiztionType = () => {
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [editModal, setEditModal] = useState(false);

    const columns = useMemo(
        () => [
            {
                Header: "Organiztion Type Name",
                accessor: "name",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const data = useMemo(
        () => [
            {
                name: 'Associate Partner',

            },
            {
                name: 'Billing Entity',
            },
            {
                name: 'Channel Partner',
            },
            {
                name: 'Client',
            },
            {
                name: 'Vendors Partner',
            },
        ],
        []
    );

    const actions = ['edit', 'delete']
    const subActions = []

    const initialValues = {
        name: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            //setLoadings(true);
            setAddModal(false);
            setEditModal(false);
            //setAddModal(false);
            //setEditModal(false);

            // const formData = new FormData();
            // formData.append('leadName', values.leadName);
            // formData.append('clientType', values.clientType);
            // formData.append('stage', values.stage);
            // formData.append('source', values.source);
            // formData.append('assignee', values.assignee);

            // try {
            //     const res = await postGeneralForms(postData);
            //     toast.success(res.data.message);
            //     setLoadings(false);
            //     setShowModal(false);

            // } catch (error) {
            //     setLoadings(false);
            //     toast.error(error.response?.data?.message || "Error submitting data");
            // }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const handleConfirm = () => {
        setAddModal(false);
        setEditModal(false);
        formik.resetForm();
    };

    const handleEdit = (rowData) => {
        setFieldValue('name', rowData.name);

        setEditModal(true);
    };

    const handleDelete = (rowData) => {
    };



    return (
        <>
            <PageTitle titles="Organiztion Type" active="Organiztion Type" items={['Home']} />
            <Row>
                <Col sm={12} className="col-12">
                    <Card>
                        <Card.Body className="example1-table">
                            <div className='custompageHed'>
                                <Row>
                                    <Col md={6}>
                                        <div className='pagetitle_hed'>
                                            <h1>Organiztion Type</h1>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className='w-100 d-flex justify-content-end'>
                                            <Button
                                                variant="primary"
                                                onClick={() => setAddModal(true)}
                                            >
                                                Add New
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <Tables
                                columns={columns}
                                data={data}
                                actions={actions}
                                subActions={subActions}
                                onEdit={handleEdit}
                                onDelete={handleDelete}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title="Add New"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Organiztion Type Name</label>
                                <input
                                    type='text'
                                    id="name"
                                    name="name"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.name && touched.name && (
                                    <p className="errormsg">{errors.name}</p>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={editModal}
                handleClose={() => setEditModal(false)}
                title="Edit Organiztion Typ"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Organiztion Type Name</label>
                                <input
                                    type='text'
                                    id="name"
                                    name="name"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.name && touched.name && (
                                    <p className="errormsg">{errors.name}</p>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Update</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>
        </>
    )
}

export default OrganiztionType